module.exports = __webpack_public_path__ + "img/gx.48a6faa.png";